import classNames from 'classnames';
import React from 'react';
import { Link } from 'react-router-dom';
import styles from './SystemAlert.module.scss';
function SystemAlert({ to, onClick, leftIcon, aside, children }) {
    const classes = classNames(styles.wrap, { [styles.clickable]: to || onClick });
    const handleClick = (e) => {
        if (onClick) {
            onClick(e);
        }
    };
    const content = (React.createElement(React.Fragment, null,
        leftIcon && leftIcon,
        children && React.createElement("p", null, children),
        aside && React.createElement("aside", null, aside)));
    if (to) {
        return (React.createElement(Link, { type: "button", role: "link", to: to, className: classes, onClick: handleClick }, content));
    }
    if (onClick)
        return (React.createElement("button", { type: "button", className: classes, onClick: handleClick }, content));
    return React.createElement("div", { className: classes }, content);
}
export default SystemAlert;
